/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `we_already_have_a_relationship_with_this_provider` - We already have a relationship with this provider
 * * `provider_has_been_presented_by_another_agency` - This provider has been presented by another agency
 * * `provider_does_not_meet_requirements` - Provider does not meet requirements
 * * `other` - Other
 */
export enum ClearanceRejectionReasonEnum {
    WE_ALREADY_HAVE_A_RELATIONSHIP_WITH_THIS_PROVIDER = 'we_already_have_a_relationship_with_this_provider',
    PROVIDER_HAS_BEEN_PRESENTED_BY_ANOTHER_AGENCY = 'provider_has_been_presented_by_another_agency',
    PROVIDER_DOES_NOT_MEET_REQUIREMENTS = 'provider_does_not_meet_requirements',
    OTHER = 'other',
}
